import { gql } from '@apollo/client';
import {
  GetResolvedImageQuery,
  GetResolvedImageQueryVariables,
} from '../../__generated__/queries-image';
import { useGetter } from '../useGetter';

export const GET_RESOLVED_IMAGE = gql`
  query GetResolvedImage($key: String!) {
    getResolvedImage(key: $key) {
      url
    }
  }
`;

export const useResolvedImageGetter = () =>
  useGetter<GetResolvedImageQuery, GetResolvedImageQueryVariables>(
    GET_RESOLVED_IMAGE,
  );
